__webpack_require__.p = "https://lib.bgsu.edu/template/2.0.0-b11/";